
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinar/usa-study-event",
      function () {
        return require("private-next-pages/webinar/usa-study-event.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinar/usa-study-event"])
      });
    }
  